import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetCascadedPlansApi from "../api/plans/GetCascadedPlansApi";
import { SimpleLoader } from "./sub/Loaders";
import TopPlanElement from "./TopPlanElement";

function TopPlansSpace(props) {
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPlanId, setCurrentPlanId] = useState();
  const [startAt, setStartAt] = useState(0);
  const [totalChildCount, setTotalChildCount] = useState(0);
  const [isCascadedPlanDeleted, setIsCascadedPlanDeleted] = useState(false);
  const [isPlanCascaded, setIsPlanCascaded] = useState(false);

  useEffect(() => {
    if (data.length === 0) {
      if (props.activeKeys.includes(props.planId)) {
        getCascadedPlans(props.planId, startAt);
        setCurrentPlanId(props.planId);
      }
    }
  }, [props.activeKeys]);

  useEffect(() => {
    if (props.cascadedData) {
      if (!props.collapse) {
        const newData = data;
        newData.push(props.cascadedData);
        setData(newData);
        setTotalChildCount(totalChildCount + 1);
        setIsPlanCascaded(true);
        setStartAt(startAt + 10 + 1);
      } else {
        getCascadedPlans(props.planId, startAt);
      }
    }
  }, [props.cascadedData]);

  async function getCascadedPlans(id, num) {
    setLoading(true);
    const apiResponse = await GetCascadedPlansApi(
      perfCycleState.id,
      id,
      positionState.id,
      num,
      10
    );
    if (apiResponse.message === "success") {
      // Ensure display follows hierarchy order (orderIndex ASC), fallback to createdOn
      const next = [...data, ...apiResponse.data.plans].sort((a, b) => {
        const ai = typeof a.orderIndex === "number" ? a.orderIndex : 999999;
        const bi = typeof b.orderIndex === "number" ? b.orderIndex : 999999;
        if (ai !== bi) return ai - bi;
        const at = new Date(a.createdOn).getTime?.() || 0;
        const bt = new Date(b.createdOn).getTime?.() || 0;
        return at - bt;
      });
      setData(next);

      setTotalChildCount(apiResponse.data?.totalCount);
      setIsCascadedPlanDeleted(false);
      setIsPlanCascaded(false);
    }
    setLoading(false);
  }

  function handleDelete(planId) {
    setIsCascadedPlanDeleted(true);
    setTotalChildCount(totalChildCount - 1);
    setStartAt(startAt + (10 - 1));

    const newData = [];
    data.forEach((element) => {
      if (planId !== element.planId) {
        newData.push(element);
      }
    });
    setData(newData);
  }
  function handleEdit(editedPlan) {
    const newData = [];
    data.forEach((element) => {
      if (editedPlan.planId === element.planId) {
        newData.push(editedPlan);
      } else {
        newData.push(element);
      }
    });
    setData(newData);
  }

  return (
    <>
      {data?.map((element) => (
        <TopPlanElement
          key={element.planId}
          data={element}
          handleDelete={(planId) => handleDelete(planId)}
          handleEdit={(planId) => handleEdit(planId)}
          handleDeleteChange={(planId, totalChildCount) =>
            props.handleDeleteChange(planId, totalChildCount)
          }
          totalChildCount={totalChildCount}
          onHierarchyChange={() => {
            // Refresh the cascaded plans when hierarchy changes
            getCascadedPlans(props.planId, 0);
          }}
        />
      ))}

      {loading ? (
        <SimpleLoader />
      ) : totalChildCount > data.length ? (
        <div className="flex items-center justify-center mt-2">
          <Button
            className="mb-2"
            onClick={() => {
              getCascadedPlans(
                currentPlanId,
                isCascadedPlanDeleted || isPlanCascaded ? startAt : startAt + 10
              );
              setStartAt(startAt + 10);
            }}
          >
            Load more
          </Button>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default TopPlansSpace;
